// Sélecteur de langue du menu Réglages : bascule immédiate (indépendante des réglages dev,
// ne marque jamais devModeUsed puisque la langue n'affecte en rien le score ou le gameplay).
import { $ } from './dom.js';

export function createLanguageSwitcher({ onSelect }) {
  const buttons = [$('btnLangFr'), $('btnLangEn')];

  function reflect(lang) {
    buttons.forEach((btn) => btn.setAttribute('aria-pressed', String(btn.dataset.lang === lang)));
  }

  buttons.forEach((btn) => btn.addEventListener('click', () => onSelect(btn.dataset.lang)));

  return { reflect };
}
